import { useCallback, useState } from "react";
import { TConsultores } from "../../../../../types/api/comercial/consultores";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import DialogCriacaoEditConsultores from "./DialogCriacaoEditConsultores";

export default function Consultores() {

  const [openModal, setOpenModal] = useState<TOpenModalConsultor>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TConsultores | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<TConsultores>
        titulo="Consultores"
        endpoints={{
          listar: "comercial/configuracoes/pesquisar-consultores",
          deletar: "comercial/configuracoes/excluir-consultor",
        }}
        colunas={colunas}
        queryKey="pesquisar-consultores"
        queryParams={{
          incluir_deletados: "true",
        }}
        onEditar={(consultor) => {
          handleModalAction("open", consultor.id, consultor)
        }}
        onAdicionar={() => {
          handleModalAction("open", true,)
        }}
        mensagemSucessoDeletar="Consultor deletado com sucesso!"
        mensagemErroDeletar="Erro ao deletar consultor!"
        podeEditar={(item) => item.status !== 'Removido'}
        podeDeletar={(item) => item.status !== 'Removido'}
      />

      {
        Boolean(openModal?.open) &&
        <DialogCriacaoEditConsultores
          open={Boolean(openModal?.open)}
          handleClose={() => { handleModalAction("close") }}
          defaultValue={openModal?.defaultValue ? openModal : null}
        />
      }
    </>
  );
}

export type TOpenModalConsultor = {
  open: number | boolean | null;
  defaultValue: TConsultores | null;
} | null

const colunas: ConfiguracaoColunas<TConsultores>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  },
  {
    campo: "status",
    titulo: "Status"
  }
];
